import { CanGoOutAloneCondition } from '../../lib/types/models/can-go-out-alone-condition/can-go-out-alone-condition'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCanGoOutAloneCondition(id: number) {
  return restApiClient
    .url(constructApiUrl(API.canGoOutAloneCondition.get.url, { id }))
    .get<CanGoOutAloneCondition>()
}
